export default "__VITE_ASSET__DBgfBRDq__"